import {
  GET_DAILY_REPORTS,
  GET_DAILY_REPORT,
  CREATE_DAILY_REPORT,
  UPDATE_DAILY_REPORT,
  DELETE_DAILY_REPORT,
  APPROVE_DAILY_REPORT
} from '../actions/dailyReportActions';

const initialState = {
  dailyReports: [],
  dailyReport: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const dailyReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DAILY_REPORTS:
      return {
        ...state,
        dailyReports: action.payload.reports,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };

    case GET_DAILY_REPORT:
      return {
        ...state,
        dailyReport: action.payload,
        isLoading: false
      };

    case CREATE_DAILY_REPORT:
      return {
        ...state,
        dailyReports: [action.payload, ...state.dailyReports]
      };

    case UPDATE_DAILY_REPORT:
    case APPROVE_DAILY_REPORT:
      return {
        ...state,
        dailyReports: state.dailyReports.map(r =>
          r._id === action.payload._id ? action.payload : r
        ),
        dailyReport: action.payload
      };

    case DELETE_DAILY_REPORT:
      return {
        ...state,
        dailyReports: state.dailyReports.filter(r => r._id !== action.payload)
      };

    default:
      return state;
  }
};

export default dailyReportReducer;
